module.exports = __webpack_public_path__ + "assets/img/ds2.d81fdbee.jpg";